import styles from './Agenda.module.scss';
import {useSelector} from 'react-redux';
import moment from 'moment/moment';
import {useTranslation} from 'react-i18next';
import {NavLink} from 'react-router-dom';

// Card layout for future events
function EventCard(props) {
  const {t} = useTranslation('agenda');

  // Get artist image from first artist in the event (uses cp-thumb thumbnail)
  const firstArtist = props.artists?.[0];
  const artistImage = firstArtist?.image?.find(img => img.key === 'thumb' || img.key === 'banner')?.url;

  return (
    <div className={styles.card}>
      {artistImage && (
        <div className={styles['card__image']}>
          <img src={artistImage} alt={firstArtist.name} />
        </div>
      )}

      <div className={styles['card__content']}>
        {props.showArtists && props.artists.length > 0 && (
          <div className={styles['card__artists']}>
            {props.artists.map((artist, index) => (
              <NavLink
                key={index}
                to={'/artists/' + artist.slug}
                className={styles['card__artist']}
              >
                {artist.name}
              </NavLink>
            ))}
          </div>
        )}

        <div className={styles['card__date']}>
          {props.date.format('ll')}
        </div>

        <div className={styles['card__place']}>
          {props.event_name && <p className={styles['card__event-name']}>{props.event_name}</p>}
          {props.place_name && <p>{props.place_name}</p>}
          {props.place_address && <p>{props.place_address}</p>}
          {(props.place_city || props.place_zipcode) && (
            <p>{props.place_city ?? ''} {props.place_zipcode ?? ''}</p>
          )}
        </div>

        {(props.tickets_url || props.event_url) && (
          <div className={styles['card__links']}>
            {props.tickets_url && (
              <a href={props.tickets_url} target="_blank" rel="noreferrer">
                {t('links.tickets')}
              </a>
            )}
            {props.event_url && (
              <a href={props.event_url} target="_blank" rel="noreferrer">
                {t('links.event')}
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// Original list layout for past events
function EventItem(props) {
  const {t} = useTranslation('agenda');
  return (
    <div className={styles.item + (props.passed ? ' ' + styles['item-passed'] : '')}>
      <div className={styles['item__main']}>
        <div className={styles['item__date']}>{props.date.format('ll')}</div>

        {props.showArtists && (
          <div>
            <div className={styles['item__separator']}></div>
            <div className={styles['item__artists']}>
              {props.artists.map((artist, index) => {
                return (
                  <span key={index} className={styles['item__artist']}>
              <NavLink to={'/artists/' + artist.slug}>{artist.name}</NavLink>
            </span>
                );
              })
              }
            </div>
          </div>
        )}
      </div>

      <div className={styles['item__infos']}>
        <p className={styles['item__name']}>
          {props.event_name || props.place_name}
        </p>
        <div className={styles['item__place']}>
          {props.event_name && (<p>{props.place_name}</p>)}
          {props.place_address && (<p>{props.place_address} </p>)}
          {(props.place_city || props.place_zipcode) && (<p>{props.place_city ?? ''} {props.place_zipcode ?? ''}</p>)}
          {false && props.place_country && (<p>{t('countries.' + props.place_country)}</p>)}
        </div>
      </div>

      {!props.passed && (props.tickets_url || props.event_url) && (
        <div className={styles['item__links']}>
          <div className={styles['item__arrow']}>
          </div>

          {props.tickets_url &&
           (<span><a href={props.tickets_url} target="_blank" rel="noreferrer">{t('links.tickets')}</a></span>)}
          {props.event_url &&
           (<span><a href={props.event_url} target="_blank" rel="noreferrer">{t('links.event')}</a></span>)}
        </div>
      )}

    </div>
  );
}

function Agenda(props) {
  const content = useSelector(state => state.content.value);

  let events = content.agenda.map(event => {
    return {...event, date: moment(event.date)};
  });

  if (props.artist_slug) {
    events = events.filter(event => {
      return event.artists.some(artist => artist.slug === props.artist_slug);
    });
  }

  const now = moment();
  const passed_events = events.filter(event => {
    return event.date < now;
  }).sort((a, b) => (b.date - a.date));

  const upcoming_events = events.filter(event => {
    return event.date >= now;
  }).sort((a, b) => (a.date - b.date));

  if (props.setAgendaCount) {
    props.setAgendaCount(upcoming_events.length);
  }

  // Show only upcoming events or past events based on props
  const eventsToShow = props.showPastOnly ? passed_events : upcoming_events;
  const isGridLayout = !props.showPastOnly;

  return (
    <div>
      <div className={isGridLayout ? styles.grid : styles.list}>
        {eventsToShow.map((event, index) => {
          return isGridLayout ? (
            <EventCard
              showArtists={!props.artist_slug}
              key={index}
              {...event}
            />
          ) : (
            <EventItem
              showArtists={!props.artist_slug}
              passed={props.showPastOnly}
              key={index}
              {...event}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Agenda;